package org.zest.insan_360_website.utils

fun getSearchScore(query: String, target: String): Int {
    val q = query.lowercase().trim()
    val t = target.lowercase().trim()

    if (q == t) return 0
    if (t.contains(q)) return (t.length - q.length)

    var v0 = IntArray(t.length + 1) { it }
    var v1 = IntArray(t.length + 1)
    for (i in q.indices) {
        v1[0] = i + 1
        for (j in t.indices) {
            val cost = if (q[i] == t[j]) 0 else 1
            v1[j + 1] = minOf(v1[j] + 1, v0[j + 1] + 1, v0[j] + cost)
        }
        val temp = v0
        v0 = v1
        v1 = temp
    }
    return v0[t.length] * 10 + 100
}